import DefaultRenderer from './default';
import filters from '../../components/filters';
import loadMore from '../../components/loadMore';
import { productThumbnail } from '../../templates/single-product-thumbnail';
import SplitText from '../../util/SplitText.min.js';
import gsap from 'gsap';

class products extends DefaultRenderer {
	onEnter() {
		super.onEnter();
		let mainScroll = this.mainController.getScroll();

		const { __ } = wp.i18n;

		// We need to set car container size manually
		// to make sure the category labels stay in same place (they are placed width percentages)
		let carContainer = document.getElementById('car-container'),
			carImg = carContainer.getElementsByTagName('img')[0],
			carLabels = carContainer.getElementsByClassName('car-part-filter');

		let setContainerSize = () => {
			carContainer.style.width = carImg.naturalWidth + 'px';
			carContainer.style.height = carImg.naturalHeight + 'px';
		};

		carImg.onload = () => setContainerSize();
		setContainerSize();

		// -- Init Values
		let productLabel = new SplitText(document.getElementById('product-label'), {
			type: 'chars',
		});
		gsap.from(productLabel.chars, {
			duration: 1.5,
			y: 150,
			stagger: 0.05,
			ease: 'expo.out',
			delay: 0.2,
		});

		gsap.from(carLabels, {
			duration: 1.5,
			autoAlpha: 0,
			y: 20,
			stagger: 0.1,
			ease: 'expo.inOut',
			delay: 0.2,
			onComplete: () => {
				gsap.set(carLabels, { clearProps: 'transform' });
			},
		});

		// Filters
		let placeholders = document.getElementsByClassName('placeholder'),
			loadMoreContainer = document.getElementById('load-more-container'),
			loadMoreButton = document.getElementsByClassName('load-more')[0],
			newGrid = document.getElementById('new-container'),
			productCount = document.getElementById('product-count'),
			clearSelection = document.getElementById('clearSelection');

		let animateData = data => {
			let cardTl = gsap.timeline(),
				currentProducts = document.getElementsByClassName('product-card');

			cardTl.to(currentProducts, {
				duration: 0.4,
				y: 50,
				autoAlpha: 0,
				ease: 'back.in(2)',
				stagger: 0.05,
				onComplete: () => {
					gsap.to([loadMoreContainer, loadMoreButton], {
						duration: 0,
						autoAlpha: 0,
						onComplete: () => {
							loadMoreContainer.style.display = 'none';
							loadMoreButton.style.display = 'none';
						},
					});

					let newProducts = [];
					newGrid.innerHTML = '';
					for (let index = 0; index < data.content.length; index++) {
						const newElement = data.content[index];
						let div = document.createElement('div');
						div.innerHTML = newElement.trim();
						let newProduct = div.firstChild;
						gsap.set(newProduct, {
							autoAlpha: 0,
							y: -50,
						});
						newGrid.appendChild(newProduct);
						newProducts.push(newProduct);
					}

					if (data.found !== productCount) {
						productCount.innerHTML = data.found;
					}

					gsap.to(newProducts, {
						duration: 1.5,
						y: 0,
						autoAlpha: 1,
						ease: 'power4.out',
						stagger: 0.05,
					});

					mainScroll.update();
				},
			});
		};

		filters('sodecia_product', animateData, mainScroll);

		clearSelection.addEventListener('click', function() {
			gsap.to(newGrid.getElementsByClassName('cell'), {
				duration: 0.4,
				y: 50,
				autoAlpha: 0,
				ease: 'expo.in',
				stagger: 0.05,
				onComplete: () => {
					newGrid.style.display = 'none';
					newGrid.innerHTML = '';

					gsap.to([loadMoreContainer, loadMoreButton], {
						duration: 0,
						autoAlpha: 1,
						onComplete: () => {
							loadMoreContainer.style.display = 'flex';
							loadMoreButton.style.display = 'flex';

							gsap.to(loadMoreContainer.getElementsByClassName('cell'), {
								duration: 1.2,
								y: 0,
								autoAlpha: 1,
								ease: 'power4.inOut',
								stagger: 0.05,
								onComplete: () => {
									if (mainScroll) {
										mainScroll.update();
									}
								},
							});
						},
					});
				},
			});

			gsap.to(this, { duration: 0.3, autoAlpha: 0, ease: 'power4.out' });

			for (let index = 0; index < placeholders.length; index++) {
				placeholders[index].classList.remove('chosen');
				placeholders[index].querySelector('span').innerHTML = __('Show all', 'sodecia');
			}
		});

		/**
		 * Label Click Handler
		 */
		for (let index = 0; index < carLabels.length; index++) {
			const label = carLabels[index];
			const termId = label.dataset.id;
			label.addEventListener('click', function() {
				if (label.classList.contains('active')) {
					return;
				}

				for (let j = 0; j < carLabels.length; j++) {
					if (this !== carLabels[j] && carLabels[j].classList.contains('active')) {
						carLabels[j].classList.remove('active');
					}
				}
				label.classList.add('active');

				// Trigger filter click
				document.querySelector('.filter-data .term[data-id="' + termId + '"').click();

				setTimeout(() => {
					mainScroll.scrollTo(document.getElementsByClassName('filter-input')[0]);
				}, 500);
			});
		}

		// Remove active classes on labels after clear selection is pressed
		document.getElementById('clearSelection').addEventListener('click', () => {
			for (let index = 0; index < carLabels.length; index++) {
				const label = carLabels[index];
				label.classList.remove('active');
			}
		});

		/**
		 * Load More: Archive Page Example
		 */
		loadMore(
			{
				buttonEl: document.querySelector('.js-load-more'), //Button DOM Element
				containerEl: document.getElementById('load-more-container'), //Container Element where new post will be appended
				resource: 'sodecia_product', //Post Type to fetch
				query: {
					per_page: 9, // Accepts any WP Rest API query args
				},
				callback: productThumbnail, // Your Template function. See two examples above.
				showSpinner: true, // Do you want to show a loading spinner?
			},
			mainScroll,
		);
	}

	onLeave() {
		super.onLeave();
	}

	onEnterCompleted() {
		super.onEnterCompleted();
		function getParameterByName(name, url) {
			if (!url) url = window.location.href;
			//eslint-disable-next-line
      name = name.replace(/[\[\]]/g, '\\$&');
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		}

		var filterID = getParameterByName('filter');
		if (filterID && filterID != null) {
			document.querySelector('.car-part-filter[data-id="' + filterID + '"]').click();
		}
	}
}

export default products;



// WEBPACK FOOTER //
// ./scripts/highway/renderers/products.js